import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

import Button from '@material-ui/core/Button';

import ModalBox from '../Modals/ModalBox';
import { Notepad } from '../Notepad/Notepad';

import './style.css';

class Header extends Component {
    state = {
        modalHtml: ""
        , modalCallBack: this.modalCallBack
        , openModal: false
    }

    componentDidUpdate(prevProps, prevState){
        if(this.state.openModal && prevProps.newNotes.length !== this.props.newNotes.length){
            this.openNotebook();
        }
    }

    doLogout = () => {
        sessionStorage.removeItem("loginUser");
        sessionStorage.removeItem("loginPass");
        window.location.reload();
    }

    modalCallBack = (result, keepModalOpen) => {
        this.setState({ 
            openModal: keepModalOpen
            , hideModalButtons: false
            , modalClass: ''
        });
    }

    openNotebook = () => {
        this.setState({
            modalHtml: <Notepad 
                        closeModal={this.closeSegmentationModal} 
                        isAdmin={this.props.isAdmin} 
                        loginData={this.props.loginData}
                        newNotes={this.props.newNotes}
                        getUnseenNotes={this.props.getUnseenNotes} />
            , hideModalButtons: true
            , openModal: true
            , modalClass: 'notebookModal'
            , modalCallBack: this.modalCallBack
        });
    }

    render() {
        const { isAdmin, loginData, isLoggedIn, config, websiteSettings, newNotes } = this.props;
 
        return (
            <header id="header">
                <div className="container">
                    <div className="displayTable">
                        <div className="displayTableCell">
                            <h1><NavLink to="/"><img className="logo" src={process.env.PUBLIC_URL + config.images.logo} alt={websiteSettings?.ShortName} title={websiteSettings?.ShortName} /></NavLink>
                            {websiteSettings?.Name}</h1>
                        </div>
                        <div className="displayTableCell text-right">
                            <div className="d-print-none">
                                { isLoggedIn &&
                                    <div className="loggedInfo row">
                                        <div>
                                            <p>Olá <NavLink to={"/Users/" + loginData.Id}>{loginData && loginData.Name}</NavLink></p>
                                            {config.features.notepad && (isAdmin || loginData.profile.Notepad) && <button className="linkButton" onClick={this.openNotebook}><i className="fas fa-book-open"></i>Notas{Boolean(newNotes.length) && <span className="newNotes">{newNotes.length}</span>}</button>}
                                            {config.features.products && (isAdmin || loginData.profile.Cart) && <NavLink className="linkButton" activeClassName="active" to="/Cart"><i className="fa fa-shopping-cart"></i>Compra</NavLink>}
                                            {config.features.payments && (isAdmin || loginData.profile.Payments) && <NavLink className="linkButton" activeClassName="active" to="/Payments"><i className="fa fa-money-bill-alt"></i>Pagamentos</NavLink>}
                                        </div>
                                        <div>
                                            <Button variant="contained" color="primary" onClick={this.doLogout}>Logout</Button>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.openModal && <ModalBox modalCallBack={this.state.modalCallBack} hideButtons={this.state.hideModalButtons} bigModal={this.state.bigModal} modalClass={this.state.modalClass} isActive={this.state.openModal} modalHtml={this.state.modalHtml} />}
            </header>
        );
    }
}

export default Header;
